"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sum = exports.clamp = void 0;
const clamp = (value, min, max) => {
    if (max && value > max)
        return max;
    if (value < min)
        return min;
    return value;
};
exports.clamp = clamp;
const sum = (...values) => {
    if (!values?.length)
        return 0;
    return values.reduce((total, v) => total + v);
};
exports.sum = sum;
